<script>
  import { tourFunctions } from '../tour-functions'
  const { parseContent } = tourFunctions;
  
  function fixTitle(title) {
    return title.replace(/\[.*?\]/g, ' ');
  }
  
  function canShowHotspot(hotspot) {
    return !!hotspot.title;
  }
  
  export let tour;
  export let instructions;
  let { scenes } = tour;
  let selectedSceneId = scenes[0]?.id || '';
  let isNavigating = false;
  
  function navigateToScene(id) {
    isNavigating = true;
    selectedSceneId = id;
    let targetElement = 
      document.getElementById(id === 'instructions' ? 'instructions' : 'scene-' + id);
    targetElement.scrollIntoView();
    setTimeout(() => {
      isNavigating = false;
    }, 500);
  }

  function updateNav(id) {
    selectedSceneId = id;
    // scroll nav item into view if it's not visible
    let navItem = document.getElementById('nav-scene-' + id);
    if (navItem) {
      let nav = document.querySelector('.navigation');
      let navRect = nav.getBoundingClientRect();
      let navItemRect = navItem.getBoundingClientRect();
      if (navItemRect.bottom > navRect.bottom) {
        nav.scrollTop = navItem.offsetTop;
      } else if (navItemRect.top < navRect.top) {
        nav.scrollTop = navItem.offsetTop;
      }
    }
  }

  function observeElement(e, callback) {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isNavigating) {
          callback();
        }
      });
    });

    observer.observe(e);
  }

  </script>
  
  <div class="container">
    <nav class="navigation">
      <ul>
        <li id="nav-instructions">
          <button class:active={selectedSceneId === 'instructions'} on:click={() => navigateToScene('instructions')}>
            Instructions
          </button>
        </li>
        {#each scenes as scene}
              <li id={`nav-scene-${scene.id}`}>
            <button 
              class:active={scene.id === selectedSceneId}
              on:click={() => navigateToScene(scene.id)}>
              {fixTitle(scene.title)}
            </button>
          </li>
        {/each}
      </ul>
    </nav>
    
    <div class="content">
      <!-- show instructions -->
      <!-- {#if instructions} -->
        <div id="instructions">
          <h1>Virtual Tour Hotkeys</h1>
          <div class="instruct">
            <h2 use:observeElement={() => updateNav('instructions')}>Move View Around</h2>
            <img src="images/instructions/computer_key_Arrow_Down.png" alt="Arrow Down Key" width="60" />
            <img src="images/instructions/computer_key_Arrow_Left.png" alt="Arrow Left Key" width="60" />
            <img src="images/instructions/computer_key_Arrow_Right.png" alt="Arrow Right Key" width="60" />
            <img src="images/instructions/computer_key_Arrow_Up.png" alt="Arrow Up Key" width="60" />
          </div>
      
          <div class="instruct">
            <h2>Interact with Hotspot Near center of Screen</h2>
            <img src="images/instructions/computer_key_Enter.png" alt="Enter or Return Key" width="120" />
          </div>
      
          <div class="instruct">
            <h2>Close Popup Screens</h2>
            <img src="images/instructions/computer_key_Esc.png" alt="Esc Key" width="60" />
          </div>
      
          <div class="instruct">
            <h2>Previous &amp; Next Scene:</h2>
            <img src="images/instructions/computer_key_Less_than_Comma.png" alt="Less than Comma Key" width="60" />
            <img src="images/instructions/computer_key_Greater_than_Period.png" alt="Greater than Period Key" width="60" />
          </div>
      
          <div class="instruct">
            <h2>Toggle Scene Selection Grid</h2>
            <img src="images/instructions/computer_key_Space_bar.png" alt="Spacebar Key" width="360" />
          </div>
        </div>
      <!-- {/if} -->

      {#each scenes as scene}
      <div class="scene" id={"scene-" + scene.id}>
          <h1 use:observeElement={()=>updateNav(scene.id)}>Scene: {fixTitle(scene.title)}</h1>
          <div class="image">
            <img src={scene.thumbUrl} alt={fixTitle(scene.title)} width={1.5*250} height={1.5*156}>
          </div>
          <div class="infos">
            {#each scene.hotspots as hotspot}
              {#if canShowHotspot(hotspot)}
              <div class="info" id={"hotspot_" + hotspot.id}>
                <h2>Hotspot: {hotspot.title}</h2>
                {#if hotspot.popupImage}
                <div class="image">
                  <img src={hotspot.popupImage} alt={fixTitle(hotspot.title)} height="250">
                </div>
                {/if}
                {#if hotspot.popupVideoEmbed}
                  <div class="video">
                    <a class="button" href={hotspot.popupVideoEmbed} target="_blank">Play Video</a>
                  </div>
                {/if}
                <div class="text">
                  <p>{@html parseContent(hotspot.popupText)}</p>
                </div>
              </div>
              {/if}
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </div>
  
  <style>
    .container {
      display: flex;
      flex-direction: row;
    }
  
    .navigation {
      flex: 0 0 250px;
      padding: 1rem;
      position: sticky;
      top: 0;
      max-height: 75vh;
      margin: 2em 0;
      overflow: hidden;
      overflow-y: auto;
    }
  
    .content {
      flex: 1;
      padding: 1rem;
      overflow: auto;
    }
  
    .navigation ul {
      list-style: none;
      padding: 0;
      color: white;
      margin: 0;
    }
  
    .navigation li {
      margin: 0;
    }
  
    .navigation button {
      display: inline;
      background: none;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      padding: 0.5em;
      text-align: left;
      color: #fff;
      margin: 3px 0;
      font-size: 1.15em;
      text-decoration: underline;
    }
  
    .navigation button.active {
      font-weight: bold;
      background: #fff;
      color: var(--theme-color);
    }
  
    .scene {
      border-bottom: 1px solid rgba(255,255,255,0.25);
      padding: 1rem;
    }
  
    .scene h1, .scene h2 {
      font-family: 'Oswald', Arial, Helvetica, sans-serif;
    }
  
    p {
      line-height: 1.5;
    }
  
    img {
      border-radius: 10px;
    }
  
    .button {
      padding: 0.5em 0.75em;
      font-size: 1.25em;
      display: inline-block;
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
      font-weight: bold;
      margin: 0.25em 0;
      border-radius: 10px;
    }

    .button:hover {
      background: #fff;
      color: var(--theme-color);
    }
  
   .text a {
      font-size: 1em;
      padding: 0;
      color: #000;
      background: none;
      border: none;
      font-weight: bold;
    }

    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      background: #fff;
    }

    ::-webkit-scrollbar-thumb:hover{
      background: #ddd;
    }
    /* mobile */
    @media (max-width: 768px) {
      .container {
        flex-direction: column;
      }
  
      .navigation {
        display: none;
      }
  
      .content {
        flex: 1;
        padding: 0;
      }
  
      .scene {
        padding: 0;
        margin: 0;
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }

  </style>
  